import { render } from "./OrderBackOutboxQueueList.vue?vue&type=template&id=626ec38a"
import script from "./OrderBackOutboxQueueList.vue?vue&type=script&lang=js"
export * from "./OrderBackOutboxQueueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__